import styles from "./Solutions.module.css";

function Solutions() {
        return (
                <div className={styles.solution_page}>
                        <div className={styles.solution_hero}>
                                <div className={styles.hero_left}>
                                        <h1>We help solve</h1>
                                </div>
                                <div className={styles.vertical_divider}>
                                        
                                </div>
                                <div className={styles.hero_right}>
                                <h4>
                                        Our solutions are designed to help businesses communicate clearly, stand out visually, and maintain consistency across every surface and location.
                                </h4>
                        </div>
                        </div>
                        
                </div>
        )
}

export default Solutions
